export default __webpack_public_path__ + "static/wordpress_service_banner-c89e2bc1799ca995f7323af7f615fce2.svg";